import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id: string | number;
  username: string;
  email?: string;
  role: string;
  token: string;
}

interface AuthStore {
  isAuthenticated: boolean;
  user: AuthUser | null;
  setUser: (user: AuthUser) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      setUser: (user) => set({ isAuthenticated: true, user }),
      clearUser: () => set({ isAuthenticated: false, user: null }),
    }),
    { name: 'ptns-auth' },
  ),
);
